import { Directive, ElementRef, HostListener, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: 'textarea[nxAutoResize]'
})
export class AutoResizeTextareaDirective implements AfterViewInit, OnDestroy {
  private resizeObserver?: ResizeObserver;

  constructor(private elementRef: ElementRef<HTMLTextAreaElement>) {}

  ngAfterViewInit(): void {
    // Initial resize with a slight delay to ensure DOM is ready
    setTimeout(() => {
      this.resize();
    }, 0);

    // Also observe for when the element becomes visible (e.g., in overlays)
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.resize();
      });
      this.resizeObserver.observe(this.elementRef.nativeElement);
    }
  }

  @HostListener('input')
  onInput(): void {
    this.resize();
  }

  private resize(): void {
    const textarea = this.elementRef.nativeElement;

    // Reset height to auto to get the correct scrollHeight
    textarea.style.height = 'auto';

    // Set height to scrollHeight
    textarea.style.height = textarea.scrollHeight + 'px';

    // Handle max-height overflow
    if (textarea.style.maxHeight) {
      const maxHeight = parseFloat(textarea.style.maxHeight);
      if (textarea.scrollHeight >= maxHeight) {
        textarea.style.overflowY = 'scroll';
        textarea.style.height = maxHeight + 'px';
      } else {
        textarea.style.overflowY = 'hidden';
      }
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
